import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const EmbryoTransferIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M11.67,2.52H9.3A7.37,7.37,0,0,0,3.52,4.87,8.37,8.37,0,0,0,1.2,10.75a7.93,7.93,0,0,0,2.08,5.41,7.78,7.78,0,0,0,5.09,2.71l.39,0-1.33,1.5a1,1,0,0,0,0,1.4A1.05,1.05,0,0,0,8.8,21.7l3.08-3.13a1,1,0,0,0,0-1.41L8.8,14a.94.94,0,0,0-.69-.29.92.92,0,0,0-.68.29,1,1,0,0,0,0,1.4l1.38,1.41-.61-.1a6,6,0,0,1-3.56-2.12,6,6,0,0,1,.61-8.47A5.68,5.68,0,0,1,9.42,4.53h2.25a.93.93,0,0,0,1-1A.94.94,0,0,0,11.67,2.52Z" />
      <path d="M18.61,2.4a4.26,4.26,0,0,0,0,8.52A4.23,4.23,0,0,0,22.8,6.66,4.28,4.28,0,0,0,18.61,2.4Zm0,6.75a2.49,2.49,0,0,1,0-5,2.57,2.57,0,0,1,2.46,2.49A2.57,2.57,0,0,1,18.61,9.15Z" />
      <path d="M18.61,14.09A3.9,3.9,0,1,0,22.44,18,3.87,3.87,0,0,0,18.61,14.09Z" />
    </SvgIcon>
  )
}
export default EmbryoTransferIcon
